import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { generateGuid, ItemBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { ModifierSetBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifersetbase';
import { ModifierSetOptionBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifieroptionbase';
import { VariantBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-variantbase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
// import { stat } from 'fs';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Discount } from '@src/app/ecom-models/discount';
import { LanguageService } from '@src/app/ecom-services/ecom-language-service';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';
import { ToastService } from '@src/app/toast/toast.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomItemUpsellPopupComponent } from '../ecom-item-upsell-popup/ecom-item-upsell-popup.component';
import { EcomDetailService } from './ecom-item-detail.service';
declare var chatWindowLoad: Function;
@Component({
  selector: 'app-ecom-item-details2',
  templateUrl: './ecom-item-details2.component.html',
  styleUrls: ['./ecom-item-details2.component.scss']
})
export class EcomItemDetails2Component implements OnInit {
  @Input() item?: ItemBase;

  @Input() item_pkid?: number;
  @Input() iscvsd_pkid?: number;
  @Input() category_pkid?: number;
  @Input() onClose?: () => void;

  @Input() upSellId: number = 0;
  isOptionsCollapsed = false;
  isSidesCollapsed = true;
  option1 = 0;
  option2 = 0;
  option3 = 0;
  sides1 = 0;
  sides2 = 0;
  itemCount = 0;
  isSelected = false;
  itemSelected: any;
  locationSelected: any;
  serviceType = 'DINE_IN';
  settings: any;
  itemDetails: ItemBase;
  itemDetailsModal: ItemBase;
  alerts: any[] = [{
    type: 'warning',
    msg: 'limit exceeds',
    timeout: 5000,
    isOpen: false
  }];
  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  specialRequest = '';
  itemClicked: any;
  modalRef: BsModalRef;

  @ViewChild('combinationPopup', { static: true }) combinationPopup: ElementRef;
  configorderstatus = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  orderstatusModalRef: BsModalRef;
  modalAddToCartRef: BsModalRef;
  modalGetDiscountRef: BsModalRef;

  bsModalRef: BsModalRef;
  customer_order: any;
  combinationPopupRef: BsModalRef;

  seletedModifiers: string[] = [];
  upSellItems: any[] = [];
  freeItems: ItemBase[] = [];
  maxQuantity: number = 0;
  fixedMaxQuantity: number = 0;
  totalFreeItemsSelected: number = 0;

  totalBuyItemsSelected: number = 0;

  totalGetItemsSelected: number = 0;
  discountTitle: string;
  discountApplied: boolean = false;
  additionalMessage: string;
  isFree: boolean = false;
  upSellItems2: any;
  // constructor to inject the class objects

  handleCloseDiscount?: () => void;
  getQuantity: number = 0;
  toastMessage: string = '';
  showToast: boolean = false;
  combinationList: ItemBase[] = [];
  discountCaption: string = "";
  minBuyQuantity: number = 0;
  combinationBuyItems: ItemBase[] = [];
  showModifierPopup: boolean = false;
  combo: { optionName: string; description: string; originalPrice: number; salePrice: number; itemsToAdd: (string | ItemBase)[]; }[] = [];
  comboSelected: string = '';
  showBuyAndGet: boolean;
  buyItems: ItemBase[] = [];
  getItems: ItemBase[] = [];
  showGetItems: boolean = false;
  maxGetQuantity: number;
  freeTitle: string;
  totalModItems: number = 0;

  constructor(public router: Router, public ecomservice: EComService,
    private webstorage: EComWebStorage, private modalService: BsModalService,
    public languageService: LanguageService,
    private toastService: ToastService,
    private settingService: EcomSettingService,
    private itemDetailService: EcomDetailService,
    private translate: TranslateService) {
    this.itemDetails = new ItemBase();
    this.itemDetailsModal = new ItemBase();
    this.userServiceBase = new UserServiceBase();


    this.toastService.message$.subscribe(message => {
      this.toastMessage = message;
    });

    this.toastService.visibility$.subscribe(visible => {
      this.showToast = visible;
    });

    this.settingService.currentCompanySetting.subscribe(setting => {
      if (!setting) return;

      this.serviceType = setting.serviceType;
    });

    this.settingService.currentLocationSetting.subscribe(location => {
      if (!location) return;

      this.userSelectedStore = this.settingService.getSelectedStore(this.serviceType);
    });

    this.settingService.currentLocationSetting.subscribe(settings => {
      this.settings = settings;
    });
  }

  // component initialize and load the required data
  async ngOnInit() {

    if (!this.item && !this.item_pkid && !this.category_pkid && !this.iscvsd_pkid) return;

    if (this.item) {
      this.itemDetails = this.item;
      this.specialRequest = this.item.specialRequest;

      this.loadDefaultData();
      return;
    }

    this.webstorage.sessionSt_qr_scan_current_page = this.router.url;
    // window.scroll({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
    this.option1 = 0;
    this.option2 = 0;
    this.option3 = 0;
    this.sides1 = 0;
    this.sides2 = 0;
    this.itemCount = 0;
    this.isOptionsCollapsed = false;
    this.isSidesCollapsed = true;
    if (!this.settingService.getCompanySetting()) {
      this.router.navigate(['stores']);
    } else if (this.webstorage.sessionSt_item_selected === null) {
      this.router.navigate(['items', this.webstorage.sessionSt_company_clicked]);
    } else {
      this.loadDefaultData();
      await this.LoadPage();
    }

  }


  async fetchUpsellItems(itemId: number) {
    const companyId = this.settings.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;
    const response = await this.ecomservice.httpPost(`${EcomNetworkUtils.GET_ITEMS_UPSELL_BY_IDS}`, { companyId: companyId, ids: [itemId], locationPkid: locationPkid }, '', false)
      .toPromise();
    if (response.status === 200) {
      this.upSellItems2 = response.listValues;
    }

  }

  loadDefaultData() {
    //this.settings = this.webstorage.sessionSt_settings;
    //this.serviceType = this.webstorage.sessionSt_service_type;
    // this.itemSelected = this.webstorage.sessionSt_item_selected;
    this.locationSelected = this.settingService.getLocationSetting();
    this.userServiceBase = this.settingService.getUserSerivce();
  }

  async LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      const response = await this.ecomservice.httpPost(url, {}, '', true).toPromise();
      if (response.isSuccess) {
        if (!this.webstorage.localSt_client_id) {
          this.webstorage.localSt_client_id = response.listValue.oock_client_id;
        }
        // store public key
        this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
        //this.getItemDetails();
      }

    }
    await this.getItemDetails();

    if (!this.upSellId) await this.fetchUpsellItems(this.item_pkid);

  }

  // Method to get the item details
  async getItemDetails() {
    //console.log('getItemDetails');

    this.serviceType = this.webstorage.sessionSt_service_type;
    const selectedStore = this.settingService.getSelectedStore(this.serviceType);
    this.userSelectedStore = selectedStore;

    const companyId = this.locationSelected.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;
    const model = {
      companyId: companyId,
      locationPkid: locationPkid,
      itemPkid: this.item_pkid,
      categoryPkid: this.category_pkid,
      orderDateTime: Date.now(),
      orderType: this.serviceType,
      queryDiscount: true,
      variantId: this.iscvsd_pkid,
      upSellId: this.upSellId
    };

    const itemDetails = await this.fetchItemDetails(model);
    if (!itemDetails) {
      this.toastService.show("Item not found!");
      this.onClose();
      return;
    }
    this.itemDetails = itemDetails;
    this.setDefaults2(this.itemDetails);
    this.mapDiscounts(this.itemDetails);
    await this.fetchDiscountedItems(this.itemDetails, model.variantId, this.itemDetails.discounts);
  }

  async fetchItemDetails(model) {
    try {
      //this.ecomservice.loadingPage.loading = true;

      const response = await this.ecomservice.httpPost(
        `${EcomNetworkUtils.GET_ITEM_DETAILS}`,
        model, '', false
      ).toPromise();

      //this.ecomservice.loadingPage.loading = false;

      if (response.status === 200) {
        const itemDetails = response.listValue;

        if (!itemDetails) {
          this.toastService.show("Item not found!");
          this.onClose();
          return null;
        }

        return this.mapItemBase(itemDetails);
      }

      return null; // Trả về null nếu không có item
    } catch (error) {
      this.ecomservice.loadingPage.loading = false;
      console.error('Error fetching item details:', error);
    }
  }


  processModifiers(modifiers: any[]): any[] {

    let processedModifiers: any[] = [];
    modifiers.forEach(modifier => {
      processedModifiers.push(modifier);
      if (modifier.modifiers_into_modifier && modifier.modifiers_into_modifier.length > 0) {
        processedModifiers = processedModifiers.concat(this.processModifiers(modifier.modifiers_into_modifier));
      }
    });
    return processedModifiers;
  }

  mapDiscounts(item: ItemBase) {
    return;
    //item.discounts = itemDetails.discounts;
    //console.log("debbuger")
    const discountIds = item.discounts.map(x => x.discount_pkid);
    const localDiscounts = this.settingService.getDiscounts().filter(x => discountIds.includes(x.discount_pkid));


    for (const i of localDiscounts) {
      //console.log(i.isAvailable)
      const numProps = Object.keys(i.applications).length;

      if (numProps) {
        const totalApplications = Object.values(i.applications).reduce((total: number, count: number) => total + count, 0) as number;
        i.isAvailable = i.discount_max_uses_per_order === null ? true : totalApplications < i.discount_max_uses_per_order;
        if (i.isAvailable) i.selected = false;
      }


    }
    item.discounts = localDiscounts.filter(x => x.isAvailable);
  }

  async fetchDiscountedItems(item: ItemBase, iscvsd_pkid: number, discounts) {
    if (!item.discounts.length) return;
    const discount = discounts[0] as Discount;

    const localDiscount = this.settingService.getDiscounts().find(x => x.discount_pkid === discount.discount_pkid);

    if (localDiscount) {
      if (localDiscount.discount_max_uses_per_order) {
        const appliedDiscountCount = localDiscount.applications[discount.discount_pkid];
        if (appliedDiscountCount === localDiscount.discount_max_uses_per_order) return;
      }
    }

    this.discountCaption = discount.discount_caption ? discount.discount_caption : discount.discount_name;

    item.selectedDiscountId = discount.discount_pkid;
    // discount_minimum_requirement == NONE and MIN 1=> same no need to show popup
    if (discount.discount_minimum_requirement === "NONE") return;

    if (discount.discount_primary_type === "BUY_GET") {
      this.maxGetQuantity = discount.discount_get_quantity;
      const buyIds = discount.discount_buy_iscvsd_pkid.split(',').map(Number);
      if (discount.discount_value_type === "FREE") {
        this.isFree = true;
        this.getQuantity = discount.discount_get_quantity;
        if (discount.discount_get_quantity === 1) {
          this.freeTitle = `1 Free Item`;
        }
        else {
          this.freeTitle = `Choose ${discount.discount_get_quantity} Free Items`;
        }

      }
      //new
      if (buyIds.length > 0) {
        item.selectedDiscountId = discount.discount_pkid;
        this.combinationPopupRef = this.modalService.show(this.combinationPopup, { ...this.configorderstatus, class: 'modal-dialog-centered modal-md' });
        const lst = await this.fetchItemsByIds(buyIds);
        if (!lst.length) return;
        const combo = this.itemDetailService.createComboBuyGet(lst, discount.discount_buy_quantity, discount);
        this.combo = combo;

        this.combinationList = lst;


        const getIds = discount.discount_get_iscvsd_pkid.split(',').map(Number);
        this.getItems = await this.fetchItemsByIds(getIds);
        this.getItems.forEach(gi => this.calculateDiscountAmount(gi, discount));

        this.showBuyAndGet = true;

        return;
      }
      //new     
    }


    if (['PERCENTAGE_AMOUNT', 'FIXED_AMOUNT'].includes(discount.discount_primary_type)) {
      let itemIds = [];
      if (discount.discount_primary_type === 'FIXED_AMOUNT' && discount.discount_iscvsd_pkid) {
        itemIds = discount.discount_iscvsd_pkid.split(',').map(Number);
      }

      if (discount.discount_primary_type === 'PERCENTAGE_AMOUNT' && discount.discount_buy_iscvsd_pkid) {
        itemIds = discount.discount_buy_iscvsd_pkid.split(',').map(Number);
      }
      // discount.discount_minimum_requirement_quantity === 2;
      if (discount.discount_minimum_requirement_quantity === 1) {
        item.selectedDiscountId = discount.discount_pkid;
        return;
      }

      if (itemIds.length > 0) {
        item.selectedDiscountId = discount.discount_pkid;
        this.combinationPopupRef = this.modalService.show(this.combinationPopup, { ...this.configorderstatus, class: 'modal-dialog-centered modal-md' });
        const lst = await this.fetchItemsByIds(itemIds);
        if (!lst.length) return;
        const combo = this.itemDetailService.createCombo(lst, discount.discount_minimum_requirement_quantity ? discount.discount_minimum_requirement_quantity : 1, discount);
        this.combo = combo;

        this.combinationList = lst;
        return;
      }


    }


    return;
  }

  calculateDiscountAmount(item: ItemBase, discount: Discount) {
    switch (discount.discount_value_type) {
      case "FREE":
        item.discountedPrice = 0;
        break;
      case "FIXED":
        item.discountedPrice = discount.discount_value;
        break;
      case "AMOUNT":
        item.discountedPrice = item.priceEach - discount.discount_value;
        break;
      case "PERCENTAGE":
        const discountRate = discount.discount_value / 100;
        item.discountedPrice = item.priceEach - (item.priceEach * discountRate);
        break;
      default:
        item.discountedPrice = item.priceEach; // No discount applied
    }
  }
  async fetchItemsByIds(ids: number[]) {
    const companyId = this.settings.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;
    const response = await this.ecomservice.httpPost(`${EcomNetworkUtils.GET_ITEMS_FREE_BY_IDS}`, { companyId: companyId, ids: ids, locationPkid: locationPkid }, '', false)
      .toPromise();
    this.ecomservice.loadingPage.loading = false;

    if (response.status === 200 && response.listValues.length) {
      const items = response.listValues.map(item => {
        return this.mapItemBase(item);
      });
      return items
    }
    return [];

  }

  mapItemBase(item) {
    const itemDetails = new ItemBase({
      earning_points: item.mm_items_standard_composite_variant_service_details.length > 0 && item.mm_items_standard_composite_variant_service_details[0].earning_points,
      has_benefit_count: item.mm_items_standard_composite_variant_service_details.length > 0 && item.mm_items_standard_composite_variant_service_details[0].has_benefit_count,
      itemGuid: item.item_pkid,
      itemName: item.item_name,
      itemAlternativeName: item.item_alternative_name,
      itemDescription: item.item_description,
      imagePath: item.item_image,
      imageColor: item.item_color,
      isValid: true,
      HasModifier: item.HasModifiers,
      has_discount: item.iscvsd_has_discount,
      iscvsd_pkid: item.iscvsd_pkid
    });

    if (item.HasModifiers) {
      itemDetails.itemModId = `${item.item_pkid}-${item.iscvsd_pkid}`;
    }

    itemDetails.discounts = item.discounts && item.discounts.map(x => new Discount(x));


    const taxtype = this.settings.company_sell_price_tax;

    const tax = item.mm_items_standard_composite_variant_service_details.length > 0 && item.mm_items_standard_composite_variant_service_details[0].mm_taxes;
    if (tax) {
      itemDetails.tax = tax;
    }
    // variants
    item.mm_items_standard_composite_variant_service_details.forEach(element => {
      const taxRate = element.mm_taxes.tax_rate;
      let dineInPrice = element.online_order_item_pricing.ooip_price_value;
      let deliveryCollectionPrice = element.online_order_item_pricing.ooip_price_value;
      let dineInPriceDiscounted = element.online_order_item_pricing.ooip_dinein_discount_price_value;
      let collectionPriceDiscounted = element.online_order_item_pricing.ooip_collection_delivery_discount_price_value;
      let deliveryPriceDiscounted = element.online_order_item_pricing.ooip_delivery_discount_price_value;
      //taxAmountDineIn = this.calculateTax(taxtype === 'TAX_IN' ? 'TAX_IN' : 'TAX_EX', dineInPriceDiscounted > 0 ? dineInPriceDiscounted : dineInPrice, taxRate);

      const variant = new VariantBase({
        variant_oadp: element.online_order_item_pricing.ooip_oadp,
        variantGuid: element.iscvsd_pkid,
        variantName: element.iscvsd_name,
        variantAlternativeName: element.iscvsd_alternative_name,
        variantDineInPrice: Number(Number(dineInPrice).toFixed(2)),
        variantDeliveryCollectionPrice: Number(Number(deliveryCollectionPrice).toFixed(2)),
        variantDineInPriceDiscounted: Number(Number(dineInPriceDiscounted).toFixed(2)),
        variantCollectionPriceDiscounted: Number(Number(collectionPriceDiscounted).toFixed(2)),
        variantDeliveryPriceDiscounted: Number(Number(deliveryPriceDiscounted).toFixed(2)),
        variantMaxPerOrder: element.online_order_item_pricing.ooip_max_per_order,
        variantMaxPerDay: element.online_order_item_pricing.ooip_max_per_day,
        selected: false,
        variantTaxGuid: element.mm_taxes.tax_guid,
        variantTaxRate: taxRate,
        variantAvailable: element.online_order_item_pricing.ooip_is_active && element.online_order_item_pricing.availableForSelctedDateTime,
        variantSKU: element.iscvsd_sku,
        outofstock: element.outofstock
      });
      itemDetails.variantList.push(variant);
    });
    // modifiers
    item.mm_items_modifier_mappings.forEach(element => {

      const modifier = new ModifierSetBase({
        modifiermappingGuid: element.imm_guid,
        modifierGuid: element.imm_modifier_guid,
        modifierName: element.modifier_name,
        modifierCaption: element.modifier_caption,
        modifierSetMin: element.imm_modifier_minimum,
        modifierSetMax: element.imm_modifier_maximum,
        modifierOptions: [],
        collapsed: false,
        quantity: 0,
      });

      //modifier.selectedOptions = [];
      const modifierOptions = [];
      element.mm_items_modifier_mapping_options.forEach(option => {
        let modifierOptionPrice = option.mm_items_modifier_options.modifier_option_price;
        const modifierTaxRate = option.mm_items_modifier_options.mm_taxes.tax_rate;

        let modifierTax = 0;

        // no need to add the tax
        //modifierTax = this.calculateTax(taxtype === 'TAX_IN' ? 'TAX_IN' : 'TAX_EX', modifierOptionPrice, modifierTaxRate);


        let optionData = this.ModifierSetOptionMapData(option, modifierTaxRate, modifierTax, modifier, taxtype);

        if (option.mm_items_modifier_options.modifiers_into_modifier.length) {

          const modifiers_into_modifier = option.mm_items_modifier_options.modifiers_into_modifier.map(x => this.ModifierSetOptionMapData(x, modifierTaxRate, modifierTax, modifier, taxtype, true));
          optionData = { ...optionData, modifiers_into_modifier: modifiers_into_modifier }
        }
        modifierOptions.push(optionData);
      });
      // sort by price
      //modifierOptions.sort((a, b) => a.optionPrice < b.optionPrice ? -1 : a.optionPrice > b.optionPrice ? 1 : 0);
      modifier.modifierOptions = modifierOptions;

      itemDetails.modifierSetList.push(modifier);
    });
    //this.setDefaults();
    this.setDefaults2(itemDetails, 0);

    const selectedOptionPkids = (itemDetails.modifierSetList || [])
      .reduce((pkids, set) => pkids.concat(set.modifierOptions.filter(o => o.optionSelected).map(o => o.optionPkid)), [] as number[]);

    if (selectedOptionPkids.length > 0) {
      const modId = selectedOptionPkids.join('-');
      itemDetails.itemModId = `${itemDetails.itemGuid}-${itemDetails.iscvsd_pkid}-${modId}`;
    }

    return itemDetails;
  }

  private processModifierLevels(modifiers: any[], level: number, modifierTaxRate, modifierTax, modifier, taxtype) {
    let lst: any[] = []
    modifiers.forEach(modifier => {
      //console.log("Level " + level + ": " + modifier.mm_items_modifier_options.modifier_option_name);
      if (modifier.mm_items_modifier_options.modifiers_into_modifier.length > 0) {
        const modifiers_into_modifier = modifier.mm_items_modifier_options.modifiers_into_modifier.map(x => this.ModifierSetOptionMapData(x, modifierTaxRate, modifierTax, modifier, taxtype, true));
        //const optionData = { ...optionData, modifiers_into_modifier: modifiers_into_modifier }
        this.processModifierLevels(modifier.mm_items_modifier_options.modifiers_into_modifier, level + 1, modifierTaxRate, modifierTax, modifier, taxtype);
      } else {
        // Last lv
      }
      //return lst;
    });

    //return lst
  }
  ModifierSetOptionMapData(option, modifierTaxRate, modifierTax, modifier, taxtype, modifiers_into_modifier = false) {
    const modiferOption = new ModifierSetOptionBase({
      has_modifiers_into_modifier: modifiers_into_modifier,
      option_oadp: option.option_oadp,
      optionGuid: option.immo_guid,
      optionPkid: option.immo_pkid,
      option_pkid: option.immo_modifier_option_pkid,
      optionName: option.mm_items_modifier_options.modifier_option_name,
      imm_item_pkid: option.mm_items_modifier_options.imm_item_pkid
    });

    const { dinein_discount_price_value } = option;
    modiferOption.optionPrice = dinein_discount_price_value > 0 ? dinein_discount_price_value : option.mm_items_modifier_options.modifier_option_price;
    // if (this.serviceType === "COLLECTION") {
    //   modiferOption.optionPrice = collection_delivery_discount_price_value > 0 ? collection_delivery_discount_price_value : option_collection_price;
    // }
    modiferOption.optionPreSelected = option.immo_preselect;
    modiferOption.optionQuantity = 0;
    modiferOption.optionTaxRate = modifierTaxRate;
    modiferOption.optionTaxAmt = Number(modifierTax.toFixed(2));
    modiferOption.optionTaxGuid = option.mm_items_modifier_options.mm_taxes.tax_guid;
    modiferOption.optionSelected = option.immo_preselect;
    if (modiferOption.optionPreSelected) {
      modiferOption.optionQuantity = 1;
      modifier.quantity = modifier.quantity + 1;
      modifier.modifierSetSelected = true;
    }
    //option price discounted and actual 
    modiferOption.optionDineInPrice = option.option_dinein_price;
    modiferOption.optionDineInPriceDiscounted = option.option_dinein_price_discounted;
    modiferOption.optionCollectionPrice = option.option_collection_price;
    modiferOption.optionCollectionPriceDiscounted = option.option_collection_price_discounted;
    modiferOption.tax = option.mm_items_modifier_options.mm_taxes;
    // modiferOption.optionDeliveryPrice = option.option_delivery_price;
    // modiferOption.optionDeliveryPriceDiscounted = option.option_delivery_price_discounted;

    // no need to add the tax   

    return modiferOption;
  }

  setDefaults2(item, quantity?: number) {
    // set the variant selected from item picked
    // check if the lowest price item is sold out then pick the item within the stock
    const result = item.variantList.find(obj => obj.variantGuid === this.iscvsd_pkid && !obj.outofstock);
    if (result === undefined) {
      let vindexnext = -1;
      const resultnext = item.variantList.find((obj, index) => {
        vindexnext = index;
        return !obj.outofstock && obj.variantAvailable;
      });
      if (resultnext !== undefined) {
        item.variantList[vindexnext].selected = true;
        item.variantList[vindexnext].variantQty = quantity !== undefined ? 1 : quantity;
        item.priceEach = item.variantList[vindexnext].variantDineInPriceDiscounted ? item.variantList[vindexnext].variantDineInPriceDiscounted : item.variantList[vindexnext].variantDineInPrice;
        // if (this.serviceType === 'COLLECTION') {
        //   item.priceEach = item.variantList[vindexnext].variantCollectionPriceDiscounted ? item.variantList[vindexnext].variantCollectionPriceDiscounted : item.variantList[vindexnext].variantDeliveryCollectionPrice;
        // }
        // add modifier set options price to total if preselected
        item.modifierSetList.forEach(modifier => {
          modifier.modifierOptions.forEach(option => {
            if (option.optionPreSelected) {
              if (this.serviceType === 'DINE_IN') {
                const price = option.optionDineInPriceDiscounted > 0 ? option.optionDineInPriceDiscounted : option.optionDineInPrice;

                item.priceEachAfterDiscount = item.priceEachAfterDiscount + option.optionDineInPriceDiscounted;
                item.priceEachBeforeDiscount = item.priceEachBeforeDiscount + option.optionDineInPrice;
                item.priceEach = item.priceEach + price;
                item.taxEach = item.taxEach + option.optionTaxAmtDineIn;
              }
              // item.priceEach = item.priceEach + option.optionPrice;
              // item.taxEach = item.taxEach + option.optionTaxAmt;
            }
          });
        });
      }
    } else {
      let vindexnext = -1;
      const resultActive = item.variantList.find((obj, index) => {
        vindexnext = index;
        return obj.variantAvailable;
      });
      if (resultActive) {
        item.variantList[vindexnext].selected = true;
        item.variantList[vindexnext].variantQty = quantity !== undefined ? quantity : 1;
        item.priceEach = item.variantList[vindexnext].variantDineInPriceDiscounted ? item.variantList[vindexnext].variantDineInPriceDiscounted : item.variantList[vindexnext].variantDineInPrice;
        // if (this.serviceType === 'COLLECTION') {
        //   item.priceEach = item.variantList[vindexnext].variantCollectionPriceDiscounted ? item.variantList[vindexnext].variantCollectionPriceDiscounted : item.variantList[vindexnext].variantDeliveryCollectionPrice;
        // }
        // add modifier set options price to total if preselected
        item.modifierSetList.forEach(modifier => {
          modifier.modifierOptions.forEach(option => {
            if (option.optionPreSelected) {
              const price = option.optionDineInPriceDiscounted > 0 ? option.optionDineInPriceDiscounted : option.optionDineInPrice;

              //item.priceEach = price;

            }
          });
        });
      } else {
        item.variantList[0].selected = true;
        item.variantList[0].variantQty = quantity !== undefined ? quantity : 1;
        item.priceEach = item.variantList[vindexnext].variantDineInPriceDiscounted ? item.variantList[vindexnext].variantDineInPriceDiscounted : item.variantList[vindexnext].variantDineInPrice;
        // if (this.serviceType === 'COLLECTION') {
        //   item.priceEach = item.variantList[vindexnext].variantCollectionPriceDiscounted ? item.variantList[vindexnext].variantCollectionPriceDiscounted : item.variantList[vindexnext].variantDeliveryCollectionPrice;
        // }
        // add modifier set options price to total if preselected
        item.modifierSetList.forEach(modifier => {
          modifier.modifierOptions.forEach(option => {
            if (option.optionPreSelected) {
              if (this.serviceType === 'DINE_IN') {
                const price = option.optionDineInPriceDiscounted > 0 ? option.optionDineInPriceDiscounted : option.optionDineInPrice;

                item.priceEachAfterDiscount = item.priceEachAfterDiscount + option.optionDineInPriceDiscounted;
                item.priceEachBeforeDiscount = item.priceEachBeforeDiscount + option.optionDineInPrice;
                item.priceEach = item.priceEach + price;
                item.taxEach = item.taxEach + option.optionTaxAmtDineIn;
              }
            }
          });
        });
      }
    }

    // get selected variant
    let variantIndex = -1;
    const variantSelected = item.variantList.find((obj, index) => {
      variantIndex = index;
      return obj.selected === true;
    });
    if (variantIndex !== -1) {
      item.quantity = quantity !== undefined ? quantity : 1;
      // update the total price
      item.totalPrice = this.getTotalPrice(item);
      item.totalPriceAfterDiscount = item.variantList[variantIndex].variantQty * item.priceEachAfterDiscount;
      item.totalPriceBeforeDiscount = item.variantList[variantIndex].variantQty * item.priceEachBeforeDiscount;
      let priceDifference = item.totalPriceBeforeDiscount - item.priceEachAfterDiscount;
      if (item.totalPriceBeforeDiscount == priceDifference) {
        item.totalDiscountAmount = 0;
      } else {
        item.totalDiscountAmount = item.totalPriceBeforeDiscount - item.totalPrice;
      }
      item.totalTax = item.variantList[variantIndex].variantQty * item.taxEach;
      //console.log(item.totalTax);
    }
    //console.log(item.modifierSetList)
  }

  // Computes the display total fresh from source data (variant price + currently selected modifier options),
  // instead of relying on the item.totalPrice/priceEach/itemModifierPrice fields which get out of sync
  // across the different code paths that update them (initial load vs modifier toggle vs qty +/-).
  getTotalPrice(item: ItemBase): number {
    const variantSelected = item.variantList && item.variantList.find(v => v.selected);
    if (!variantSelected) return 0;

    const basePrice = variantSelected.variantDineInPriceDiscounted > 0
      ? variantSelected.variantDineInPriceDiscounted
      : variantSelected.variantDineInPrice;

    const modifierPrice = (item.modifierSetList || []).reduce((setTotal, set) =>
      setTotal + set.modifierOptions.filter(o => o.optionSelected)
        .reduce((optTotal, o) => optTotal + (Number(o.optionPrice) || 0), 0), 0);

    const selectedOptionPkids = (item.modifierSetList || [])
      .reduce((pkids, set) => pkids.concat(set.modifierOptions.filter(o => o.optionSelected).map(o => o.optionPkid)), [] as number[]);
    // this.someFunction(selectedOptionPkids);

    const qty = variantSelected.variantQty || item.quantity || 1;

    return Math.round((qty * (basePrice + modifierPrice) + Number.EPSILON) * 100) / 100;
  }

  // Method to handle the back button click
  onBackClick() {

  }

  // Method to handle the redirection
  closeDiscount(item: ItemBase, discount): void {
    // item.discounts.forEach((discount: any) => {
    //   discount.selected = false;
    // });
    item.selectedDiscountId = 0;
    if (this.modalGetDiscountRef) this.modalGetDiscountRef.hide();
  }


  handleBuyGet(item: ItemBase, discount: Discount) {
    let priceAfterDiscounted = 0;
    switch (discount.discount_value_type) {
      case 'FIXED':
        priceAfterDiscounted = discount.discount_value;
        item.autoDiscountPrice = discount.discount_value;
        break;
      case 'AMOUNT':
        priceAfterDiscounted = item.priceEach - discount.discount_value;
        item.autoDiscountPrice = priceAfterDiscounted;
        break;
      case 'PERCENTAGE':
        priceAfterDiscounted = item.priceEach * (discount.discount_value / 100);
        item.autoDiscountPrice = priceAfterDiscounted;
        break;
    }

    item.totalPrice = priceAfterDiscounted;
  }
  add2(item) {
    //if (this.minBuyQuantity === 0) return;
    this.totalBuyItemsSelected++;
    item.quantity++;
    // this.minBuyQuantity--;
    //this.count = item.quantity;
    this.validateBuyItemsValid();
  }

  subtract2(item) {
    if (item.quantity === 0) return;
    this.totalBuyItemsSelected--;
    item.quantity--;
    //this.minBuyQuantity++;
    //this.count = item.quantity;
    this.validateBuyItemsValid();
  }

  validateBuyItemsValid() {
    const discount = this.itemDetails.discounts && this.itemDetails.discounts[0];
    this.showGetItems = discount && this.totalBuyItemsSelected >= discount.discount_buy_quantity;


  }

  addFree11(item) {
    //if (this.minBuyQuantity === 0) return;
    this.totalGetItemsSelected++;
    item.quantity++;
    // this.minBuyQuantity--;
    //this.count = item.quantity;
    //this.validateBuyItemsValid();
  }

  subtractFree11(item) {
    if (item.quantity === 0) return;
    this.totalGetItemsSelected--;
    item.quantity--;
    //this.minBuyQuantity++;
    //this.count = item.quantity;
    //this.validateBuyItemsValid();
  }

  addFree(item) {
    if (this.maxGetQuantity === 0) return;
    this.totalGetItemsSelected++;
    item.quantity++;
    this.maxGetQuantity--;
    //this.count = item.quantity;
  }

  subtractFree(item) {
    if (item.quantity === 0) return;
    this.totalGetItemsSelected--;
    item.quantity--;
    this.maxGetQuantity++;
    // this.count = item.quantity;
  }

  onAddToCartClick(item: ItemBase) {
    if (item.selectedDiscountId) {

      const discount = this.settingService.getDiscounts().find(x => x.discount_pkid === item.selectedDiscountId);
      let appliedDiscountCount = 0;
      let max = 999;
      if (discount) {
        if (discount.discount_max_uses_per_order) {
          appliedDiscountCount = discount.applications[discount.discount_pkid] || 0;
          max = discount.discount_max_uses_per_order;
        }
        let itemIds = [];
        if (discount.discount_primary_type === 'FIXED_AMOUNT' && discount.discount_iscvsd_pkid) {
          itemIds = discount.discount_iscvsd_pkid.split(',').map(Number);
        }

        if (discount.discount_primary_type === 'PERCENTAGE_AMOUNT' && discount.discount_buy_iscvsd_pkid) {
          itemIds = discount.discount_buy_iscvsd_pkid.split(',').map(Number);
        }
        if (discount.discount_minimum_requirement === "NONE" ||
          (discount.discount_minimum_requirement === "QUANTITY"
            && discount.discount_minimum_requirement_quantity === 1
          )
        ) {
          item.quantity = item.quantity - 1;
          const maxDiscountUses = max - appliedDiscountCount - 1;

          const { discountedItems, nonDiscountedItem } = this.itemDetailService.splitItemByDiscount(item, maxDiscountUses, discount);
          item.itemsDiscounted = discountedItems;
          if (nonDiscountedItem) item.itemsDiscounted.push(nonDiscountedItem);
          item.quantity = 1;
          //return;
        }
      }

    }

    if (this.item) {
      // just update
      this.item.specialRequest = this.specialRequest;
      if (this.onClose) this.onClose();
      return;
    }
    item.iuic_pkid = this.upSellId || 0;

    this.onAddToCartClick2(item);
  }

  onAddToCartClick2(item, redirect = true) {
    this.alerts = [];
    // check for per order limit
    // get selected variant

    const variantSelected = item.variantList.find(obj => obj.selected);
    const maxPerOrder = Number(variantSelected.variantMaxPerOrder);
    if (maxPerOrder > 0) {
      if (variantSelected.variantQty > maxPerOrder) {
        this.alerts.push({
          type: 'warning',
          msg: 'per order allowed only ' + maxPerOrder + ' quantity.',
          timeout: 5000,
          isOpen: true
        });
        return;
      }
      // check with cart item if it already added
      let cartItemExceeds = false;
      this.serviceType = this.webstorage.sessionSt_service_type;
      //let userStoreIndex = -1;
      const selectedStore = this.userServiceBase.selectedStoreServiceList.find(obj =>
        // userStoreIndex = index;
        obj.serviceLocationGuid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid && !obj.serviceCompleted && obj.serviceType === this.serviceType
      );
      //let cartItemIndex = -1;
      let cartItem: any = '';
      if (this.userSelectedStore.storeCart && this.userSelectedStore.storeCart.orderItems) {
        cartItem = this.userSelectedStore.storeCart.orderItems.find(obj =>
          //cartItemIndex = index;
          obj.itemGuid === item.itemGuid && obj.variantList[0].variantGuid === variantSelected.variantGuid
        );
      }
      if (cartItem) {
        const cartItemQtyAfterAddingnew = cartItem.variantList[0].variantQty + variantSelected.variantQty;

        if (cartItemQtyAfterAddingnew > maxPerOrder) {
          this.alerts.push({
            type: 'warning',
            msg: 'per order allowed only ' + maxPerOrder + ' quantity.',
            timeout: 5000,
            isOpen: true
          });
          cartItemExceeds = true;
        }
      }
      if (cartItemExceeds) {
        return;
      }

      if (variantSelected.variantQty > maxPerOrder) {
        this.alerts.push({
          type: 'warning',
          msg: 'per order allowed only ' + maxPerOrder + ' quantity.',
          timeout: 5000,
          isOpen: true
        });
        return;
      }


    }
    // validate for modifier minimum qty selection
    item.isValid = true;
    item.modifierSetList.forEach(element => {
      const qtyModifierSetMin = Number(element.modifierSetMin);
      const qtyModifierSet = Number(element.quantity);
      const qtyModifierSetMax = Number(element.modifierSetMax);
      const selectedCount = element.modifierOptions.filter(m => m.optionSelected === true).length;
      if (qtyModifierSetMin > 0 && (qtyModifierSet < qtyModifierSetMin || selectedCount < qtyModifierSetMin)) {
        const msg = `per qty choose min ${qtyModifierSetMin} and max ${qtyModifierSetMax} options`;
        element.errorMessage = msg;
        this.toastService.show(msg);
        item.isValid = false;
        return;
      }
    });
    // check max order limit

    if (item.isValid) {
      item.specialRequest = this.specialRequest;
      this.webstorage.sessionSt_cart_item = item;
      if (this.onClose) this.onClose();

      if (this.upSellItems2 && this.upSellItems2.length > 0) {
        this.showUpsell();
      }

      const message = this.translate.instant('HOME_PAGE.ITEM_ADDED', { itemName: item.itemName });
      this.toastService.show(message);
    }
  }

  hideUpsellModal() {
    if (this.onClose) this.onClose();
    if (this.bsModalRef) this.bsModalRef.hide();

  }

  showUpsell() {
    const modalOptions = {
      class: 'modal-dialog-centered modal-sm',
      initialState: {
        onClose: this.hideUpsellModal.bind(this),
        upSellItems: this.upSellItems2
      }

    };
    this.bsModalRef = this.modalService.show(EcomItemUpsellPopupComponent, modalOptions);

    //this.bsaeModalService.openModal(EcomItemUpsellPopupComponent, modalOptions);
  }

  // Method to handle the modifier set click event
  onModifierSetClick(modifier, index, collapsed) {
    modifier.collapsed = !collapsed;
  }

  onModifierSetClick2(option, index, collapsed) {
    option.collapsed = !collapsed;
  }

  // Method the handle the modifier option check event
  onModifierOptionChecked(event, modifier, option, modifierIndex, optionIndex, modifersIntoModifier = false) {
    //modifier.collapsed = event.target.checked;
    if (event.target.checked) {

      const qtyModifierSetMax = Number(modifier.modifierSetMax) * this.itemDetails.quantity;
      const qtyModifierSet = modifier.modifierOptions.filter(x => x.optionSelected).length;
      if (qtyModifierSetMax > 0 && qtyModifierSet >= qtyModifierSetMax) {
        const message = `per qty allowed only ${Number(this.itemDetails.modifierSetList[modifierIndex].modifierSetMax)} options`;

        this.itemDetails.modifierSetList[modifierIndex].errorMessage = message;
        event.target.checked = false;
        this.toastService.show(message);
        return;
      }

      //if (modifersIntoModifier) {
      modifier.modifierOptions[optionIndex].selectedOptions.push(option.optionName);
      modifier.modifierOptions[optionIndex].selectedOptionIds.push(option.optionPkid);
      // }

      const status = this.onModiferOptionClick(modifier, option, 'PLUS', modifierIndex, optionIndex, modifersIntoModifier);
      event.target.checked = status;

    } else {
      //if (modifersIntoModifier) {
      //modifier.modifierOptions[modifierIndex].optionSelected = false;
      modifier.modifierOptions[optionIndex].selectedOptions = modifier.modifierOptions[optionIndex].selectedOptions.filter(x => x !== option.optionName);
      modifier.modifierOptions[optionIndex].selectedOptionIds = modifier.modifierOptions[optionIndex].selectedOptions.filter(x => x !== option.optionPkid);
      //}
      this.onModiferOptionClick(modifier, option, 'MINUS', modifierIndex, optionIndex, modifersIntoModifier);

    }
  }

  onModifierOptionChecked2(event, modifier, option, modifierIndex, optionIndex, modifersIntoModifier = false, option2) {
    option.collapsed = event.target.checked;
    option2.optionSelected = event.target.checked;
    if (event.target.checked) {
      if (modifersIntoModifier) {
        option.selectedOptions.push(option2.optionName);
        option.selectedOptionIds.push(option2.optionPkid);
      }

      const status = this.onModiferOptionClick(modifier, option, 'PLUS', modifierIndex, optionIndex, modifersIntoModifier);
      event.target.checked = status;

    } else {
      if (modifersIntoModifier) {
        option.selectedOptionIds = option.selectedOptionIds.filter(x => x !== option2.optionPkid);
        option.selectedOptions = option.selectedOptions.filter(x => x !== option2.optionName);
      }
      this.onModiferOptionClick(modifier, option, 'MINUS', modifierIndex, optionIndex, modifersIntoModifier);

    }
  }

  // Method to handle the modifier option click event
  onModiferOptionClick(modifier, option, type, modifierIndex, optionIndex, modifersIntoModifier) {
    option.optionSelected = type === "PLUS";
    this.itemDetails.modifierSetList[modifierIndex].errorMessage = '';
    const qtyOption = Number(option.optionQuantity);
    let qtyModifierSet = Number(modifier.quantity);
    const qtyModifierSetMax = Number(modifier.modifierSetMax) * this.itemDetails.quantity;
    const qtyModifierSetMin = Number(modifier.modifierSetMin) * this.itemDetails.quantity;
    const preselect = option.optionPreSelected;

    let itemModifierPrice = 0;
    let optionPrice = 0;

    let mods = [];
    const arr = [];
    const ids = [];
    if (modifersIntoModifier) {
      optionPrice = option.optionPrice;
      mods = option.modifiers_into_modifier.filter(x => option.selectedOptionIds.includes(x.optionPkid)).map(x => x.optionPrice);
      if (!mods.length) optionPrice = 0;

      const idArr = option.modifiers_into_modifier.filter(x => option.selectedOptionIds.includes(x.optionPkid)).map(x => x.optionPkid);
      if (idArr.length) ids.push(idArr);
    }
    else {
      this.itemDetails.modifierSetList.forEach(set => {
        const p = set.modifierOptions.filter(x => x.optionSelected).map(x => x.optionPrice);
        if (p.length) arr.push(p);
        const idArr = set.modifierOptions.filter(x => x.optionSelected).map(x => x.optionPkid);
        if (idArr.length) ids.push(idArr);
      });

    }

    for (const subArray of arr) {
      for (const num of subArray) {
        mods.push(num);
      }
    }
    const idMod = [];
    for (const subArray of ids) {
      for (const num of subArray) {
        idMod.push(num);
      }
    }
    const modId = idMod.join('-');

    this.itemDetails.itemModId = `${this.itemDetails.itemGuid}-${this.itemDetails.iscvsd_pkid}-${modId}`;

    let totalModifiersPrice = 0;
    if (mods.length) {
      totalModifiersPrice = mods.reduce((total, modifier) => total + modifier, 0);

    }
    itemModifierPrice = optionPrice + totalModifiersPrice;


    if (type === 'PLUS') {
      if (qtyModifierSetMax > 0 && qtyModifierSet >= qtyModifierSetMax) {
        this.itemDetails.modifierSetList[modifierIndex].errorMessage = 'per qty allowed only ' + Number(this.itemDetails.modifierSetList[modifierIndex].modifierSetMax) + ' options';
        return false;
      } else {
        option.optionQuantity = qtyOption + (1 * this.itemDetails.quantity);
        this.itemDetails.modifierSetList[modifierIndex].quantity = qtyModifierSet + (1 * this.itemDetails.quantity);
        //option.optionSelected = true;
        this.itemDetails.priceEach = this.itemDetails.priceEach;
        if (this.itemDetails.HasModifier) this.itemDetails.itemModifierPrice = itemModifierPrice;
      }
    } else {
      if (qtyOption > 0) {
        this.itemDetails.priceEach = this.itemDetails.priceEach;
        if (this.itemDetails.HasModifier) this.itemDetails.itemModifierPrice = itemModifierPrice;
        // this.itemDetails.taxEach = this.itemDetails.taxEach - optiontaxAmt;
        //option.optionSelected = false;
        option.optionQuantity = qtyOption - (1 * this.itemDetails.quantity);
        if (qtyModifierSet > 0) {
          this.itemDetails.modifierSetList[modifierIndex].quantity = qtyModifierSet - (1 * this.itemDetails.quantity);
        }
      }
    }

    qtyModifierSet = Number(this.itemDetails.modifierSetList[modifierIndex].quantity);

    this.itemDetails.modifierSetList[modifierIndex].modifierSetSelected = qtyModifierSet > 0;

    // get selected variant
    //let variantIndex = -1;
    const variantSelected = this.itemDetails.variantList.find(x => x.selected);
    if (!variantSelected) return;
    // // update the total price
    this.itemDetails.totalPrice = this.getTotalPrice(this.itemDetails);

    return true;
  }

  // Method to handle the item click event
  onItemClick(item, type) {
    // if (item.discounts && item.discounts.length) {
    //   this.checkDiscounts();
    //   return;
    // }
    // get selected variant
    let variantIndex = -1;
    const variantSelected = item.variantList.find((obj, index) => {
      variantIndex = index;
      return obj.selected === true;
    });
    if (variantSelected !== undefined && variantIndex !== -1) {
      const maxPerOrder = Number(item.variantList[variantIndex].variantMaxPerOrder);
      this.alerts = [];
      if (type === 'PLUS') {
        if (maxPerOrder > 0) {
          // check with cart item if it already added
          let cartItemExceeds = false;
          let serviceActiveId = this.webstorage.sessionSt_service_active_id;
          if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
            serviceActiveId = 1;
          }
          this.serviceType = this.webstorage.sessionSt_service_type;
          let userStoreIndex = -1;
          const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
            userStoreIndex = index;
            return obj.serviceLocationGuid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid && !obj.serviceCompleted && obj.serviceType === this.serviceType;
          });
          let cartItemIndex = -1;
          let cartItem: any = '';
          if (this.userSelectedStore.storeCart && this.userSelectedStore.storeCart.orderItems) {
            cartItem = this.userSelectedStore.storeCart.orderItems.find((obj, index) => {
              cartItemIndex = index;
              return obj.itemGuid === item.itemGuid && this.ecomservice.stringCompare(obj.variantList[0].variantGuid, variantSelected.variantGuid);
            });
          }
          if (cartItem) {
            let variantQty = variantSelected.variantQty;
            let totalQty = variantQty + cartItem.variantList[0].variantQty;
            if (totalQty >= maxPerOrder) {
              this.alerts.push({
                type: 'warning',
                msg: 'per order allowed only ' + maxPerOrder + ' quantity.',
                timeout: 5000,
                isOpen: true
              });
              cartItemExceeds = true;
            } else {
              cartItemExceeds = false;
            }
          }
          if (!cartItemExceeds) {
            if (variantSelected.variantQty >= maxPerOrder) {
              this.alerts.push({
                type: 'warning',
                msg: 'per order allowed only ' + maxPerOrder + ' quantity.',
                timeout: 5000,
                isOpen: true
              });
            } else {
              // update item quantity
              item.variantList[variantIndex].variantQty = item.variantList[variantIndex].variantQty + 1;
              item.quantity = item.quantity + 1;
              // update modifier quantity
              item.modifierSetList.forEach(modifierSet => {
                let setQuantity = modifierSet.quantity;
                modifierSet.modifierOptions.forEach(option => {
                  if (option.optionSelected) {
                    option.optionQuantity = option.optionQuantity + 1;
                    setQuantity = setQuantity + 1;
                  }
                });
                modifierSet.quantity = setQuantity;
              });
            }
          }
        } else {
          // update item quantity
          item.variantList[variantIndex].variantQty = item.variantList[variantIndex].variantQty + 1;
          item.quantity = item.quantity + 1;
          // update modifier quantity
          item.modifierSetList.forEach(modifierSet => {
            let setQuantity = modifierSet.quantity;
            modifierSet.modifierOptions.forEach(option => {
              if (option.optionSelected) {
                option.optionQuantity = option.optionQuantity + 1;
                setQuantity = setQuantity + 1;
              }
            });
            modifierSet.quantity = setQuantity;
          });
        }
      } else {
        if (item.variantList[variantIndex].variantQty > 1) {
          // update item quantity
          item.variantList[variantIndex].variantQty = item.variantList[variantIndex].variantQty - 1;
          item.quantity = item.quantity - 1;

          // update modifier quantity
          item.modifierSetList.forEach(modifierSet => {
            let setQuantity = modifierSet.quantity;
            modifierSet.modifierOptions.forEach(option => {
              if (option.optionSelected) {
                option.optionQuantity = option.optionQuantity - 1;
                setQuantity = setQuantity - 1;
              }
            });
            modifierSet.quantity = setQuantity;
          });
        }
      }
      // update the total price
      item.totalPrice = item.variantList[variantIndex].variantQty * (item.HasModifier ? (item.itemModifierPrice + item.priceEach) : item.priceEach);
      item.totalPriceAfterDiscount = item.variantList[variantIndex].variantQty * item.priceEachAfterDiscount;
      item.totalPriceBeforeDiscount = item.variantList[variantIndex].variantQty * item.priceEachBeforeDiscount;
      //this.updateDiscounts(item);
      //console.log("price discount", item);
      //console.log(this.languageService.selectLanguage)
    }
  }
  // Method to handle the alert close event
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = [];
  }




  closeAddItemToCart() {
    //$('.modal').css({"display": "none"});
    if (this.modalAddToCartRef) this.modalAddToCartRef.hide();
  }

  closeCombinationPopup() {
    this.itemDetails.selectedDiscountId = 0;
    if (this.combinationPopupRef) this.combinationPopupRef.hide();
  }

  handleNext() {
    debugger
    const combo = this.combo.find(x => x.optionName === this.comboSelected);
    if (combo) {

      if (combo.itemsToAdd.length === 1 || combo.itemsToAdd[0] === combo.itemsToAdd[1]) {
        const item = this.combinationList.find(x => x.itemGuid === combo.itemsToAdd[0]);

        if (item && !item.modifierSetList.length) {
          const newItem = {
            ...item,
            quantity: combo.itemsToAdd.length,
            totalQuantity: combo.itemsToAdd.length,
            // itemName: `${item.itemName} - ${index}`,
            guid: generateGuid(),
            selectedDiscountId: this.itemDetails.discounts.length > 0 ? this.itemDetails.discounts[0].discount_pkid : 0
          }
          this.closeCombinationPopup();

          this.onAddToCartClick(newItem);
          return
        }

      }


      combo.itemsToAdd.forEach((id, index) => {
        const item = this.combinationList.find(x => x.itemGuid === id);
        this.combinationBuyItems.push(this.createCombinationItem(item));
      });

      if (this.combinationBuyItems.every(x => !x.modifierSetList.length)) {
        const item1 = this.combinationBuyItems[0]
        const newItem = {
          ...item1,
          quantity: item1.quantity,
          combinationGetItems: [this.combinationBuyItems[1]],
          totalQuantity: combo.itemsToAdd.length,
          // itemName: `${item.itemName} - ${index}`,
          guid: generateGuid(),
          selectedDiscountId: this.itemDetails.discounts.length > 0 ? this.itemDetails.discounts[0].discount_pkid : 0
        }
        this.closeCombinationPopup();

        this.onAddToCartClick(newItem);
      }
    }
    this.closeCombinationPopup();
    this.showModifierPopup = true;

    //console.log("this.combinationGetItems", this.combinationBuyItems);

  }

  handleBuyGetNext() {
    const combo = this.combo.find(x => x.optionName === this.comboSelected);
    const getItems = this.getItems.filter(x => x.quantity > 0);
    if (combo) {
      // Process the items to add (combo.itemsToAdd)
      combo.itemsToAdd.forEach((id, index: number) => {
        const buyItem = this.combinationList.find(x => x.itemGuid === id);
        if (buyItem) {
          buyItem.isBuyItem = true;
          this.processItems([buyItem]);
        }
        // Process the item
      });

      this.showModifierPopup = true;

      // Process the getItems
      this.processItems(getItems);  // Process all getItems


      this.closeCombinationPopup();

      if (this.combinationBuyItems.every(x => !x.modifierSetList.length)) {
        this.showModifierPopup = false;
        const buyItems = this.combinationBuyItems.filter(x => x.isBuyItem && x.quantity > 0);
        const getItems = this.combinationBuyItems.filter(x => !x.isBuyItem && x.quantity > 0);

        if (buyItems.length > 0) {
          const item = buyItems[0];
          item.selectedDiscountId = this.itemDetails.discounts.length > 0 ? this.itemDetails.discounts[0].discount_pkid : 0;
          item.combinationBuyItems = buyItems.filter(x => x.guid !== item.guid);;
          item.combinationGetItems = getItems;
          this.onAddToCartClick(item);
          return;
        }
      }

      const firstBuy = this.combinationBuyItems.find(x => x.isBuyItem);
      if (firstBuy) firstBuy.isFirstBuy = true;
      const firstGet = this.combinationBuyItems.find(x => !x.isBuyItem);
      if (firstGet) firstGet.isFirstGet = true;
      this.totalModItems = 0;
      this.combinationBuyItems.forEach(element => {
        debugger
        if (element.modifierSetList.length > 0) {
          this.totalModItems++;
          element.itemIndex = this.totalModItems;
        }
      });
    }
  }
  processItems = (items) => {
    items.forEach(item => {
      if (item.modifierSetList.length > 0 && item.quantity > 0) {
        for (let i = 0; i < item.quantity; i++) {
          this.combinationBuyItems.push(this.createCombinationItem(item));
        }
      } else {
        this.combinationBuyItems.push(this.createCombinationItem(item, item.quantity));
      }
    });
  };
  createCombinationItem(item: ItemBase, quantity = 1) {
    return {
      ...item,
      quantity: quantity > 0 ? quantity : 1,
      totalQuantity: item.quantity,
      guid: generateGuid(),
      selectedDiscountId: this.itemDetails.discounts.length > 0 ? this.itemDetails.discounts[0].discount_pkid : 0,
      modifierSetList: item.modifierSetList.map(modifierSet => ({
        ...modifierSet,
        modifierGuid: generateGuid(),
        modifierOptions: modifierSet.modifierOptions.map(modifierOption => ({
          ...modifierOption,
          optionGuid: generateGuid()
        }))
      }))
    };
  }

  addCombinationToCart() {

    const discount = this.itemDetails.discounts && this.itemDetails.discounts[0];

    if (discount && discount.discount_primary_type === "BUY_GET" && this.combinationBuyItems.length > 0) {
      const buyItems = this.itemDetailService.mergeCartItems(this.combinationBuyItems.filter(x => x.isBuyItem && x.quantity > 0));
      const getItems = this.itemDetailService.mergeCartItems(this.combinationBuyItems.filter(x => !x.isBuyItem && x.quantity > 0));

      if (buyItems.length > 0) {
        const item = buyItems[0];
        item.selectedDiscountId = discount.discount_pkid;
        item.combinationBuyItems = buyItems.filter(x => x.guid !== item.guid);;
        item.combinationGetItems = getItems;
        this.onAddToCartClick(item);
        return;
      }
    }

    if (this.combinationBuyItems.length === 2) {
      const item = this.combinationBuyItems[0];
      item.combinationGetItems = [];
      item.combinationGetItems.push(this.combinationBuyItems[1]);
      this.onAddToCartClick(item);
    }
  }


  onCombinationModifierOptionChecked(event, item: ItemBase, modifier, option, modifierIndex, optionIndex, itemIndex, modifersIntoModifier = false) {
    //modifier.collapsed = event.target.checked;
    //console.log(item.itemName);
    //console.log(itemIndex, modifierIndex, optionIndex);

    if (event.target.checked) {
      //if (modifersIntoModifier) {
      modifier.modifierOptions[optionIndex].selectedOptions.push(`${item.itemName}-${option.optionName}`);
      modifier.modifierOptions[optionIndex].selectedOptionIds.push(option.optionPkid);
      // }

      const status = this.onCombinationModiferOptionClick(item, modifier, option, 'PLUS', modifierIndex, optionIndex, modifersIntoModifier);
      event.target.checked = status;

    } else {
      modifier.modifierOptions[optionIndex].selectedOptions = modifier.modifierOptions[optionIndex].selectedOptions.filter(x => x !== option.optionName);
      modifier.modifierOptions[optionIndex].selectedOptionIds = modifier.modifierOptions[optionIndex].selectedOptions.filter(x => x !== option.optionPkid);
      //}
      this.onCombinationModiferOptionClick(item, modifier, option, 'MINUS', modifierIndex, optionIndex, modifersIntoModifier);

    }
  }

  onCombinationModiferOptionClick(item: ItemBase, modifier, option, type, modifierIndex, optionIndex, modifersIntoModifier) {
    //console.log("onCombinationModiferOptionClick", item.itemName)
    option.optionSelected = type === "PLUS";
    item.modifierSetList[modifierIndex].errorMessage = '';
    const qtyOption = Number(option.optionQuantity);
    let qtyModifierSet = Number(modifier.quantity);
    const qtyModifierSetMax = Number(modifier.modifierSetMax) * item.quantity;
    const qtyModifierSetMin = Number(modifier.modifierSetMin) * item.quantity;
    const preselect = option.optionPreSelected;

    let itemModifierPrice = 0;
    let optionPrice = 0;

    let mods = [];
    const arr = [];
    const ids = [];
    if (modifersIntoModifier) {
      optionPrice = option.optionPrice;
      mods = option.modifiers_into_modifier.filter(x => option.selectedOptionIds.includes(x.optionPkid)).map(x => x.optionPrice);
      if (!mods.length) optionPrice = 0;

      const idArr = option.modifiers_into_modifier.filter(x => option.selectedOptionIds.includes(x.optionPkid)).map(x => x.optionPkid);
      if (idArr.length) ids.push(idArr);
    }
    else {
      item.modifierSetList.forEach(set => {
        const p = set.modifierOptions.filter(x => x.optionSelected).map(x => x.optionPrice);
        if (p.length) arr.push(p);
        const idArr = set.modifierOptions.filter(x => x.optionSelected).map(x => x.optionPkid);
        if (idArr.length) ids.push(idArr);
      });

    }

    for (const subArray of arr) {
      for (const num of subArray) {
        mods.push(num);
      }
    }
    const idMod = [];
    for (const subArray of ids) {
      for (const num of subArray) {
        idMod.push(num);
      }
    }
    const modId = idMod.join('-');

    item.itemModId = `${item.itemGuid}-${modId}`;

    let totalModifiersPrice = 0;
    if (mods.length) {
      totalModifiersPrice = mods.reduce((total, modifier) => total + modifier, 0);

    }
    itemModifierPrice = optionPrice + totalModifiersPrice;


    if (type === 'PLUS') {
      if (qtyModifierSetMax > 0 && qtyModifierSet >= qtyModifierSetMax) {
        item.modifierSetList[modifierIndex].errorMessage = 'per qty allowed only ' + Number(item.modifierSetList[modifierIndex].modifierSetMax) + ' options';
        return false;
      } else {
        option.optionQuantity = qtyOption + (1 * item.quantity);
        item.modifierSetList[modifierIndex].quantity = qtyModifierSet + (1 * item.quantity);
        //option.optionSelected = true;
        item.priceEach = item.priceEach;
        if (item.HasModifier) item.itemModifierPrice = itemModifierPrice;
      }
    } else {
      if (qtyOption > 0) {
        item.priceEach = item.priceEach;
        if (item.HasModifier) item.itemModifierPrice = itemModifierPrice;
        // this.itemDetails.taxEach = this.itemDetails.taxEach - optiontaxAmt;
        //option.optionSelected = false;
        option.optionQuantity = qtyOption - (1 * item.quantity);
        if (qtyModifierSet > 0) {
          item.modifierSetList[modifierIndex].quantity = qtyModifierSet - (1 * item.quantity);
        }
      }
    }

    qtyModifierSet = Number(item.modifierSetList[modifierIndex].quantity);

    item.modifierSetList[modifierIndex].modifierSetSelected = qtyModifierSet > 0;

    // get selected variant
    //let variantIndex = -1;
    const variantSelected = item.variantList.find(x => x.selected);
    if (!variantSelected) return;
    // // update the total price
    item.totalPrice = variantSelected.variantQty * (item.priceEach + item.itemModifierPrice);

    return true;
  }

  onModifierSetClick3(item: any, modifier: any, index: number) {
    //console.log(item);
    item.modifierSetList[0].collapsed = !modifier.collapsed
    //modifier.collapsed = !modifier.collapsed;
  }
  onOptionSelected(option) {
    this.getItems.forEach(x => x.quantity = 0);
    this.totalGetItemsSelected = 0;
    if (this.itemDetails.discounts.length > 0) {
      const discount = this.itemDetails.discounts[0];
      if (discount.discount_primary_type === "BUY_GET") {
        this.maxGetQuantity = discount.discount_get_quantity;
      }
    }


    if (this.comboSelected === option.optionName) {
      // Deselect if the option is already selected
      this.comboSelected = null;

    } else {
      // Select the clicked option
      this.comboSelected = option.optionName;
    }

    //console.log([...option.itemsToAdd]);
    if (this.getItems.length === 1 && this.getQuantity === 1) {
      const getItem = this.getItems[0];
      getItem.quantity = this.comboSelected === option.optionName ? 1 : 0;
      this.getItems = [getItem];

      if (this.comboSelected) this.totalGetItemsSelected++;
      // else {
      //   this.totalGetItemsSelected++;
      // }
    }
  }

  trackByGuid(index: number, item: any): string {
    //console.log('Tracking item with guid:', item.guid); // Debugging log
    return item.guid;
  }

}